module.exports = __webpack_public_path__ + "static/media/Orientamento 2.8cb41cbd.png";